import { Skeleton } from '@/shared/ui'

type Props = {
  className?: string
}

export const MobileRoomItemSkeleton = ({ className }: Props) => {
  return (
    <div className={className}>
      <div className="flex gap-4">
        <Skeleton className="h-[100px] w-[134px] rounded-sm" />
        <div>
          <Skeleton className="mb-0.5 h-5 w-[150px] rounded-sm" />
          <Skeleton className="mb-0.5 h-5 w-[125px] rounded-sm" />
          <Skeleton className="mb-0.5 h-4 w-[135px] rounded-sm" />
          <Skeleton className="mb-0.5 h-5 w-[110px] rounded-sm" />
          <Skeleton className="h-4 w-[185px] rounded-sm" />
        </div>
      </div>
    </div>
  )
}
